import * as React from 'react';

interface TestVotesContext {
  testVotesShowing: boolean;
  setTestVotesShowing?:
    | React.Dispatch<React.SetStateAction<boolean>>
    | undefined;
  trackSetTestVotesShowing?: (params: {
    placement: 'Presentation view menu' | 'Hotkey T';
  }) => void | undefined;
}

const DEFAULT_STATE: TestVotesContext = {
  testVotesShowing: false,
  setTestVotesShowing: () => {},
  trackSetTestVotesShowing: () => {},
};

const context = React.createContext<TestVotesContext>(DEFAULT_STATE);
context.displayName = 'TestVotesContext';
export const TestVotesProvider = context.Provider;

export const useTestVotesState = () => React.useContext(context);
